<template>
    <div>
        <modal
      name="FilingFeesPopup"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="800px"
      height="auto"
    >
      <div class="v-modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Duplicate Cases</h2>
          <span @click="$modal.hide('FilingFeesPopup');hideMe()">
            <em class="material-icons">close</em> 
          </span>
        </div>
        <form  data-vv-scope="filingFeesform" @submit.prevent>
          <div class="form-container filingFeesformcontainer mt-0"  @click="eVerifyformerrors = ''" >
            <div class="filing_fields w-100">
              <template >
                <div class="form-container pt-2 filingform_table">
                <div class="vx-row" >
                  <div class="pre_defined_sec filingFee_table hide-header pt-5" >
                     <vs-table :data="eVerifyData">
                      <template v-if="eVerifyData != []"  slot="thead">
                            <vs-th>Case Number</vs-th>
                            <vs-th>Case Status</vs-th>
                            <vs-th>Created On</vs-th>
                            <vs-th>Actions</vs-th>
                      </template>
                       
                      <template slot-scope="{ data }">  
                        <vs-tr :data="item" :key="index" v-for="(item ,index) in eVerifyData" class="vs-table--tr" >
                              <vs-td><span>{{ item.case_number }}</span></vs-td>
                              <vs-td><span>{{ item.case_status_display}}({{ item.case_status }})</span></vs-td>
                              <vs-td><span>{{ item.created_date | formatDate}}</span></vs-td>
                              <vs-td>
                            <div class="vx-col d-flex">
                              <vs-button @click="selectCase(action='CONTINUE', caseNum=item.case_number)"  class="primary-btn xs_btn mr-2 success_btn" type="filled" clas>Continue</vs-button>
                              <vs-button @click="selectCase(action='DELETE',caseNum=item.case_number)"  :disabled="false" class="save primary-btn xs_btn error_btn" type="filled">Delete</vs-button>
                                <!-- <span>
                                      <svg class="mr-3" @click="selectCase(action='CONTINUE', caseNum=item.case_number)" width="20" height="20" viewBox="0 0 12 12">
                                          <path style="cursor: pointer;" id="Path_626" data-name="Path 626" d="M6,0a6,6,0,1,0,6,6A6.023,6.023,0,0,0,6,0ZM5.274,8.729,2.646,6.1l.994-.994L5.32,6.787,8.691,3.722l.946,1.04Z" fill="#97d856"/>
                                      </svg>                                                          
                                  </span>
                                <span>
                                    <svg @click="selectCase(action='DELETE',caseNum=item.case_number)" style="cursor: pointer;" class="bin mr-5" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg>
                                </span> -->
                              </div> 
                              </vs-td>
                        </vs-tr> 
                       
                      </template>
                       
                     </vs-table>
                    </div>
                </div>
              </div>
              </template>
            </div>       
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="false"><img src="@/assets/images/main/loader.gif"/></span>
            <vs-button color="dark" @click="hideMe()" class="cancel" type="filled">Cancel</vs-button>
            <vs-button color="success" :disabled="false" class="save" type="filled">Submit</vs-button>
          </div>
        </form>
      </div>
    </modal>
    <eVerifyDupConformpopup v-if="isDupSelected"  :caseNumber="caseNumber"   @removeCase="removeCaseFromList"/>
    </div>
  </template>
  
  <script>
  import Vue from "vue";
  Vue.use(CKEditor);
  import CKEditor from "@ckeditor/ckeditor5-vue2";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  import eVerifyDupConformpopup from "./eVerifyDupConformpopup.vue";
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    data: () => ({
      caseNumber:null,
      isDupSelected:false,
      eVerifyData: [],
      eVerifyformerrors: "",
      editor: ClassicEditor,
      editorConfig: {
        toolbar: ["bold", "italic", "|", "undo", "redo", "NumberedList", "BulletedList"],
      },
    }),
    components: {
      eVerifyDupConformpopup
    },
    props: {
      petitionDetails: null,
      eVerifyDataDuplicates:null
    },
    methods: {
      removeCaseFromList(caseNumber) {
        this.eVerifyData = this.eVerifyData.filter(caseItem => caseItem.case_number !== caseNumber);
      },
       selectCase(action, caseNum){
        if(action == 'DELETE'){
            this.caseNumber = caseNum
            this.isDupSelected=true
        }
      },
      deleteItem(index) {
        this.eVerifyData.splice(index, 1);
      },
      hideMe(){
        this.$modal.hide("FilingFeesPopup");
        this.isDupSelected = false;
        this.$emit("hideDuplicates");
      }

    },
    mounted() {
        console.log('dasdad')
    if(this.eVerifyDataDuplicates){
        console.log('mounted')
        this.eVerifyData= this.eVerifyDataDuplicates
        this.$modal.show("FilingFeesPopup");
    }
    },
  };
  </script>
  